import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { SearchParam } from '../../../core/routing/param';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { FormType } from '../../backend/openapi/api-types';
import { AuthenticatedForm } from './authenticated-form';

export const AddressMutation: React.FC = () => {
  const { t } = useTranslation();
  const { profileSettingsPath } = usePathBuilder();
  const { companyName } = useSearchParam([SearchParam.companyName]);
  const queryParam = companyName ? { companyName } : undefined;

  const linkBackTo = { to: profileSettingsPath(), label: t('form.backToProfileSettings') };

  return (
    <AuthenticatedForm
      documentTitle={t('form.addressMutation.documentTitle')}
      formType={FormType.addressMutation}
      linkBackTo={linkBackTo}
      queryParam={queryParam}
    />
  );
};
